// import ovp from './implementations/mockOvp/mockOvp';
import ovp from './implementations/accedo/accedo';
import brightcove from './implementations/brightcove/brightcove';
import tmdb from './implementations/tmdb/tmdb';
import placeholder from './placeholder/placeholder';

export default ovp;
export { brightcove, placeholder, tmdb };
